// @flow

import React from "react";
import { observer } from "mobx-react";
import { Select } from "@blueprintjs/select";
import { Button, MenuItem } from "@blueprintjs/core";
import isEmpty from "lodash.isempty";

type Props = {
  cabinClasses: Array<string>,
  changeCabinClass: Function,
  className: string,
  disabled: boolean,
  selectedCabinClass: string
};

function CabinClassSelect(props: Props) {
  const { cabinClasses = [], changeCabinClass, className = "", disabled, selectedCabinClass } = props;

  const isDisabled = disabled || isEmpty(cabinClasses);

  const button = (
    <Button
      data-testid="cabin-class-selector"
      disabled={isDisabled}
      text={
        <span>
          Cabin: <strong>{selectedCabinClass}</strong>
        </span>
      }
      rightIcon="caret-down"
    />
  );

  return (
    <Select
      className={className}
      disabled={isDisabled}
      filterable={false}
      items={cabinClasses}
      itemRenderer={(item, itemProps) => <MenuItem key={item} onClick={itemProps.handleClick} text={item} />}
      onItemSelect={selection => changeCabinClass(selection)}
      popoverProps={{ minimal: true }}
    >
      {button}
    </Select>
  );
}

export default observer(CabinClassSelect);
